import './styles.scss';
import HeroComponent from './heroComponent';

import HeroLayout from 'components/Sections/Hero/HeroLayout';
import { useSelector } from 'react-redux';
import {
    selectLocationsPageIsLoading,
    selectLocationsPageHero,
    selectLocationsPageTags,
} from 'store/slices/LocationsSlice';
// import { getImageUrl } from 'helpers';
import ProxyLocationIllustration from 'components/AnimationIllustrations/ProxyLocationIllustration';
import { Helmet } from 'react-helmet';
import { generateMetaTags, getImageUrl } from 'helpers';
import useMediaQuery from 'hooks/useMediaQuery';

const Hero = () => {
    const hero = useSelector(selectLocationsPageHero);
    const isLoading = useSelector(selectLocationsPageIsLoading);
    const locationsTags = useSelector(selectLocationsPageTags);

    const { title, description, button_text, button_text_link, image } = hero;
    const imageUrl = getImageUrl(image);
    const isMobile = useMediaQuery('max-width: 640px ');

    const metaTags = generateMetaTags(locationsTags?.tag, 'meta');
    const metaTitle = generateMetaTags(locationsTags?.tag, 'title');

    return (
        <>
            <Helmet
                title={metaTitle ? `${metaTitle}` : title}
                meta={metaTags}
                script={[
                    {
                        type: 'application/ld+json',
                        innerHTML: JSON.stringify({
                            '@context': 'http://schema.org',
                            '@type': 'Service',
                            serviceType: title,
                            provider: {
                                '@type': 'Organization',
                                name: 'Ping Proxies',
                                url: 'https://www.pingproxies.com',
                            },
                            areaServed: 'Worldwide',
                            description: description,
                        }),
                    },
                ]}
            />
            <HeroLayout
                image={isMobile ? <img src={imageUrl} alt="" /> : <ProxyLocationIllustration isLoading={isLoading} />}
                isLoading={isLoading}
            >
                <HeroComponent
                    title={title}
                    desc={description}
                    button_text={button_text}
                    button_text_link={button_text_link}
                    hasCrumbs={true}
                />
            </HeroLayout>
        </>
    );
};

export default Hero;
